var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "exam" },
    [
      _c("div", { staticClass: "nuv" }, [
        _c("span", [_vm._v("群培训管理 >")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.groupName))])
      ]),
      _vm._v(" "),
      _c(
        "a",
        { staticClass: "top-button", attrs: { href: "javascript:;" } },
        [
          _c("el-button", { attrs: { type: "primary" } }, [
            _vm._v("群考核名单")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("tjkautocomplete", { on: { callBack: _vm.updateTjkId } }),
      _vm._v(" "),
      _c(
        "el-button",
        {
          staticStyle: { "margin-left": "10px" },
          attrs: { type: "danger" },
          on: { click: _vm.getList }
        },
        [_vm._v("查询淘金客")]
      ),
      _vm._v(" "),
      !_vm.success
        ? _c("p", { staticClass: "tj-shift-notice" }, [
            _vm._v(_vm._s(_vm.message))
          ])
        : [
            !_vm.list.length
              ? _c(
                  "p",
                  {
                    staticClass: "tj-shift-notice",
                    staticStyle: { "padding-top": "45px" }
                  },
                  [_vm._v("暂无记录！")]
                )
              : [
                  _c(
                    "el-table",
                    {
                      ref: "multipleTable",
                      staticStyle: { width: "100%" },
                      attrs: {
                        border: "",
                        data: _vm.list,
                        height: _vm.onlineTableHeight,
                        "tooltip-effect": "dark"
                      },
                      on: { "selection-change": _vm.handleSelectionChange }
                    },
                    [
                      _c("el-table-column", {
                        attrs: { type: "selection", align: "center" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "realName",
                          label: "考核人员",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "tjkNumber",
                          label: "淘金号",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "是否通过", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { placeholder: "请选择" },
                                    model: {
                                      value: scope.row.retrialState,
                                      callback: function($$v) {
                                        _vm.$set(scope.row, "retrialState", $$v)
                                      },
                                      expression: "scope.row.retrialState"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      key: "Passed",
                                      attrs: { label: "通过", value: "Passed" }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      key: "InRetrial",
                                      attrs: {
                                        label: "复训中",
                                        value: "InRetrial"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "passRemark",
                          label: "备注",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("el-input", {
                                  attrs: {
                                    type: "textarea",
                                    autosize: "",
                                    placeholder: "不能超过200字",
                                    clearable: ""
                                  },
                                  model: {
                                    value: scope.row.passRemark,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "passRemark", $$v)
                                    },
                                    expression: "scope.row.passRemark"
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tj-margin-top-xl" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.saveScore }
                        },
                        [_vm._v("保存打分")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "danger" },
                          on: { click: _vm.releaseGroup }
                        },
                        [_vm._v("发布成绩")]
                      )
                    ],
                    1
                  )
                ]
          ],
      _vm._v(" "),
      _c("Modal", { ref: "release" }, [
        _c(
          "h3",
          { staticStyle: { "text-align": "center", "margin-bottom": "10px" } },
          [_vm._v("所有通过学员将被T出本群，且建议复训通过。")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "tj-table tj-fill tj-padding-right-xl" }, [
          _c("dl", [
            _c(
              "dt",
              { staticClass: "tj-text-right" },
              [
                _c("font", { attrs: { color: "red" } }, [_vm._v("*")]),
                _vm._v(" 发送消息：")
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "dd",
              [
                _c("el-input", {
                  attrs: {
                    type: "textarea",
                    rows: 3,
                    placeholder: "恭喜你通过基础复训，赶快去领取任务吧。"
                  },
                  model: {
                    value: _vm.release.publishMsg,
                    callback: function($$v) {
                      _vm.$set(_vm.release, "publishMsg", $$v)
                    },
                    expression: "release.publishMsg"
                  }
                })
              ],
              1
            )
          ])
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ef13866", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ef13866","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/college/retrialExamine.vue
// module id = 1182
// module chunks = 0